import React from "react";
// Customizable Area Start
import {
  Box,
  Table,
  Paper,
  styled,
  Button,
  Popover,
  TableRow,
  TableBody,
  TableHead,
  IconButton,
  TableContainer,
  TablePagination,
  Dialog,
  Modal,
} from "@material-ui/core";

import VisibilityIcon from "@material-ui/icons/Visibility";

import { DatePicker } from "@material-ui/pickers";

import {
  FilterList as FilterIcon,
  MoreVert as MoreVertIcon,
} from "@material-ui/icons";

import DateFns from "@date-io/moment";
import { calenderIcon } from "../../CfPriceList/src/assets";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import SortingTableCell from "../../../components/src/SortingTableCell";
import SortingTableHeader from "../../../components/src/SortingTableHeader2";
import FilterPopover, { IFilter } from "../../../components/src/FilterPopover";
import { colors } from "../../../blocks/utilities/src/Colors";
import ConfirmModal from "../../../components/src/customComponents/ConfirmationModal.web";
import { LoadingComponent } from "../../../components/src/Loader.web";
import { TableRowsSkeleton } from "../../../components/src/customComponents/TableRowsSkeleton.web";
import {
  renderBaseOnConditions,
  sortStringCondition,
  conditionalString,
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { StyledFieldLabel } from "../../../components/src/customComponents/CustomTags.web";
// Customizable Area End

import StoreDiscountListController, {
  // Customizable Area Start
  S,
  Props,
  configJSON,
  ISection,
  IPlatform,
  IStoreDiscount,
  IFilterItem,
  StoreDiscountStatus,
  // Customizable Area End
} from "./StoreDiscountListController.web";

const modalStyle: any = {
  maxHeight: "calc(100vh - 126px)",
  position: "absolute",
  top: "49%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "587px",
  height: "auto",
  bgcolor: "#fff",
  borderRadius: 12,
  boxShadow: 24,
  padding: "24px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  overflowY: "auto",
  "@media (max-width: 768px)": {
    padding: "20px",
    width: "75%",
  },
};

const VIEW_STATUS_ROWS = [
  [
    {
      label: "Used Orders",
      binding: "used_orders",
    },
    {
      label: "Used Pieces",
      binding: "used_pieces",
    },
    {
      label: "Sub Total",
      binding: "subtotal",
    },
    {
      label: "Discount",
      binding: "discount",
    },
    {
      label: "Net Sale",
      binding: "net_pay",
    },
    {
      label: "Revenue",
      binding: "revenue",
    },
  ],
] as Array<Array<{ label: string; binding: keyof StoreDiscountStatus }>>;

// Customizable Area Start
const Strings = configJSON.Strings.storeDiscountList;
// Customizable Area End

class StoreDiscountList extends StoreDiscountListController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    this.state = {
      endDate: null,
      startDate: null,
      popOverTop: 0,
      popOverLeft: 0,
      sectionList: [],
      storeDiscountList: [],
      sectionSelected: [],
      popOverOpened: false,
      filters: [
        {
          title: "Store Discount Name",
          type: "autocompolete",
          value: "",
          apiKey: "store_discount",
          options: [],
        },
        {
          title: "Stores",
          type: "autocompolete",
          value: "",
          apiKey: "stores",
          options: [],
        },
        {
          title: "Section",
          type: "multipleSelect",
          value: [],
          options: [],
        },
        {
          title: "Date",
          type: "doubleDatepicker",
          value: [null, null],
        },
      ],
      filterAnchor: undefined,
      sortingData: {
        store_discount: "",
        section: "",
        platform: "",
        start_date: "",
        end_date: "",
      },
      confirmModalFlag: false,
      confirmModalType: false,
      totalCount: 10,
      permissionStatus: {
        mainPermission: false,
        createPermission: false,
        viewPermission: false,
        editPermission: false,
        deactivatePermission: false,
      },
      isLoadingPermission: false,
      isAppliedFilter: false,
      isLoading: false,
      openStoreListDialog: false,
      listingDataShow: [],
      dialogPayload: null,
      isLoadingDialog: false,
    } as S;
    // Customizable Area End
  }
  // Customizable Area Start
  getPopoverData() {
    const { popOverTop, popOverLeft, popOverOpened, permissionStatus } =
      this.state;

    return (
      <Popover
        style={{
          boxShadow: "none",
        }}
        anchorReference='anchorPosition'
        open={popOverOpened}
        onClose={() => this.setState({ popOverOpened: false })}
        anchorPosition={{
          top: popOverTop + 40,
          left: popOverLeft - 80,
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {renderBaseOnConditions(
          permissionStatus.viewPermission ||
            permissionStatus.editPermission ||
            permissionStatus.deactivatePermission,
          <div style={webStyle.popoverContainer}>
            {renderBaseOnConditions(
              permissionStatus.viewPermission,
              <Box
                data-test-id='viewButton'
                onClick={() =>
                  this.props.navigation.navigate("StoreDiscountView", {
                    id: this.popOverItemId,
                  })
                }
                sx={webStyle.popoverButton}
              >
                {Strings.view}
              </Box>,
              <></>
            )}
            {renderBaseOnConditions(
              permissionStatus.editPermission,
              <Box
                data-test-id='editButton'
                sx={webStyle.popoverButton}
                onClick={() =>
                  this.props.navigation.navigate("StoreDiscountEdit", {
                    id: this.popOverItemId,
                  })
                }
              >
                {Strings.edit}
              </Box>,
              <></>
            )}
            {renderBaseOnConditions(
              permissionStatus.deactivatePermission &&
                this.popOverItemStatus === "active",
              <Box
                data-test-id={"inactivateButton"}
                sx={webStyle.popoverButton}
                onClick={() => {
                  this.setState({
                    popOverOpened: false,
                    confirmModalFlag: true,
                  });
                }}
              >
                {Strings.deactivate}
              </Box>,
              <></>
            )}
            {renderBaseOnConditions(
              (permissionStatus.activatePermission as boolean) &&
                this.popOverItemStatus !== "active",
              <Box
                data-test-id={"activateButton"}
                sx={webStyle.popoverButton}
                onClick={() => this.onEditApi(true)}
              >
                {Strings.active}
              </Box>,
              <></>
            )}
          </div>,
          <div style={webStyle.popoverContainer}>
            <Box sx={webStyle.noPermissions}>No Permissions</Box>
          </div>
        )}
      </Popover>
    );
  }

  renderStoreDiscountStatus = (viewStatusData: StoreDiscountStatus) => (
    <div data-test-id='view-status-dialog' className='view-status-dialog'>
      {/* <h3 className="dialog-title">
          Business Account
        </h3> */}
      <div className='dialog-content'>
        {VIEW_STATUS_ROWS.map((rowElementArray, index) => (
          <div className='status-row' key={index}>
            {rowElementArray.map((rowElement) => {
              let labelNote = "";
              return (
                <div key={rowElement.binding}>
                  <StyledFieldLabel>
                    {rowElement.label + labelNote}
                  </StyledFieldLabel>
                  <p className='row-value'>
                    {viewStatusData[rowElement.binding]}
                  </p>
                </div>
              );
            })}
          </div>
        ))}
      </div>
      <div className='dialog-actions'>
        <button
          type='button'
          className='cancel-btn'
          onClick={() => this.handleToggleDialog()}
        >
          Cancel
        </button>
      </div>
    </div>
  );

  renderDialog = () => {
    const { dialogPayload } = this.state;

    if (!dialogPayload?.selectedBusinessAccount) return null;

    switch (dialogPayload.action) {
      case "View":
        return this.renderStoreDiscountStatus(
          dialogPayload.selectedBusinessAccount
        );
      default:
        return null;
    }
  };
  // Customizable Area End

  render() {
    // Customizable Area Start
    const {
      totalCount,
      sortingData,
      storeDiscountList,
      confirmModalFlag,
      confirmModalType,
      permissionStatus,
    } = this.state;
    // Customizable Area End

    return (
      // Customizable Area Start
      <MuiPickersUtilsProvider utils={DateFns}>
        <>
          <ConfirmModal
            open={confirmModalFlag}
            handleClose={() =>
              this.setState({
                confirmModalFlag: false,
                confirmModalType: false,
              })
            }
            handleConfirm={this.handleConfirmModal.bind(this)}
            title={
              !confirmModalType
                ? "Confirm Deactivate"
                : "Store Discount Deactivated"
            }
            displayItem={confirmModalType}
            message={{
              id: this.popOverItemId,
              title: this.confirmModalValue,
            }}
            dynamic={!confirmModalType}
            confirmText={!confirmModalType ? "Deactivate" : "Back to Listing"}
          />
          <MainBoxWrapper>
            <Box className='pageWrapper' style={{ paddingTop: "10px" }}>
              <div style={webStyle.headerWrapper}>
                <PageTitle>{Strings.pageTitle}</PageTitle>
                <div style={webStyle.headerButtonPartAccount}>
                  <div
                    data-test-id='filterButton'
                    onClick={(event: { currentTarget: {} } | undefined) =>
                      this.handleFilterChange(event)
                    }
                    className={sortStringCondition(
                      this.state.isAppliedFilter,
                      "filterButtonAccount active-filter-border",
                      "filterButtonAccount"
                    )}
                  >
                    <FilterIcon color={this.handleReturnColorType()} />
                    {renderBaseOnConditions(
                      this.state.isAppliedFilter,
                      <div className='filterActiveIcon'></div>,
                      <></>
                    )}
                  </div>
                  <FilterPopover
                    onClose={() => this.setState({ filterAnchor: undefined })}
                    anchor={
                      this.state.filterAnchor as HTMLDivElement | undefined
                    }
                    onFilterChange={(filters: IFilter[]) => {
                      this.setState({ filters });
                      this.onApplyFilter(filters);
                    }}
                    onClearFilter={() => {
                      let updated: IFilterItem[] = this.state.filters.map(
                        (item: IFilterItem) => {
                          if (item.title === "Date") item.value = [null, null];
                          else if (item.title === "Section") item.value = "";
                          else item.value = "";
                          return item;
                        }
                      );
                      this.setState({
                        filters: updated,
                        sectionSelected: [],
                        startDate: null,
                        endDate: null,
                      });
                      setTimeout(() => this.onApplyFilter(updated), 1000);
                    }}
                    refreshFilterState={(filters: IFilterItem[]) =>
                      this.handleSetStateFilter(filters)
                    }
                    filters={this.state.filters as IFilter[]}
                  />

                  <LoadingComponent
                    isLoading={this.state.isLoadingPermission}
                    height={44}
                    width={160}
                    isAllowed={permissionStatus.createPermission}
                    children={
                      <Button
                        data-test-id='addStoreDiscount'
                        className={"addButton"}
                        onClick={() =>
                          this.handleRedirection("StoreDiscountCreate")
                        }
                      >
                        {Strings.addStoreDiscount}
                      </Button>
                    }
                  />
                </div>
              </div>
              <TableContainer component={Paper} className='flexItem'>
                <Table style={webStyle.table} aria-label='customized table'>
                  <TableHead className='stickyHeader'>
                    <TableRow
                      style={{ background: "#204B9C", color: "#FFFFFF" }}
                    >
                      <SortingTableHeader
                        sortingData={sortingData}
                        title='Store Discount Name'
                        sortingKey='store_discount'
                        {...this.sortingProps}
                        type='left'
                        handleHeaderClick={() => null}
                      />
                      <SortingTableHeader
                        sortingData={sortingData}
                        title='Section'
                        sortingKey='section'
                        {...this.sortingProps}
                        handleHeaderClick={() => null}
                      />
                      <SortingTableHeader
                        sortingData={sortingData}
                        title='Platform'
                        sortingKey='platform'
                        {...this.sortingProps}
                        handleHeaderClick={() => null}
                      />
                      <SortingTableHeader
                        sortingData={sortingData}
                        title='Start Date'
                        sortingKey='start_date'
                        {...this.sortingProps}
                        handleHeaderClick={() => null}
                      />

                      <SortingTableHeader
                        sortingData={sortingData}
                        title='End Date'
                        sortingKey='end_date'
                        {...this.sortingProps}
                      />

                      <SortingTableHeader
                        sortingData={sortingData}
                        title='Status'
                        sortingKey='status'
                        {...this.sortingProps}
                        sortingDisabled
                      />

                      <SortingTableHeader
                        sortingData={sortingData}
                        title=''
                        type='action'
                        sortingKey=''
                        {...this.sortingProps}
                        sortingDisabled
                      />
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {storeDiscountList.map((item: IStoreDiscount) => {
                      return (
                        <TableRow
                          key={"table-row-" + item.id}
                          data-test-id={"table-row-" + item.id}
                        >
                          <SortingTableCell
                            width='22vw'
                            type='left'
                            content={item.attributes.name}
                          />
                          <SortingTableCell
                            width='22vw'
                            type='middle'
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxHeight: "45px",
                            }}
                            content={item.attributes.sections
                              .map((item: ISection) => item.name)
                              .join(", ")}
                          />
                          <SortingTableCell
                            width='22vw'
                            type='middle'
                            content={
                              <Box
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <span style={{ marginRight: 6 }}>Store</span>
                                <span>
                                  {item.attributes.store_managements.length}
                                </span>
                                <IconButton
                                  data-test-id='view-store-list'
                                  onClick={() => {
                                    this.handleStoreList(
                                      item.attributes.store_managements
                                    );
                                  }}
                                  style={{ padding: 4 }}
                                >
                                  <VisibilityIcon style={{ fontSize: 22 }} />
                                </IconButton>
                              </Box>
                            }
                          />
                          <SortingTableCell
                            width='15vw'
                            type='middle'
                            content={item.attributes.start_date}
                          />
                          <SortingTableCell
                            width='15vw'
                            type='middle'
                            content={item.attributes.end_date}
                          />
                          <SortingTableCell
                            width='22vw'
                            type='right'
                            content={
                              <Box
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <span style={{ marginRight: 6 }}>
                                  {item.attributes.status === "active"
                                    ? "Active"
                                    : "Deactivated"}
                                </span>
                                <IconButton
                                  className={"viewStatusButton"}
                                  data-test-id={"view-status-button"}
                                  onClick={() => {
                                    this.handleViewStatus(item);
                                  }}
                                  style={{ padding: 4 }}
                                >
                                  <VisibilityIcon style={{ fontSize: 22 }} />
                                </IconButton>
                              </Box>
                            }
                          />

                          <SortingTableCell
                            width='22vw'
                            type='action'
                            content={
                              <IconButton
                                data-test-id={"moreButton-" + item.id}
                                onClick={(event) => {
                                  const position =
                                    event.currentTarget.getBoundingClientRect();
                                  this.setState({
                                    popOverOpened: true,
                                    popOverLeft: position.left + window.scrollX,
                                    popOverTop: position.top + window.scrollY,
                                  });
                                  this.popOverItemStatus = String(
                                    item.attributes.status
                                  );
                                  this.popOverItemId = item.id;
                                  this.confirmModalValue = item.attributes.name;
                                }}
                              >
                                <MoreVertIcon />
                              </IconButton>
                            }
                          />

                          {this.state.openStoreListDialog && (
                            <Modal
                              open={this.state.openStoreListDialog}
                              data-test-id='store_list_modal'
                              onClose={this.handleCloseStoreList}
                              aria-labelledby='modal-modal-title'
                              aria-describedby='modal-modal-description'
                            >
                              <Box sx={modalStyle}>
                                <h4 style={webStyle.modalHeading}>Stores</h4>
                                <Box className='listingWrapper'>
                                  {this.state.listingDataShow.map(
                                    (item: any) => {
                                      return (
                                        <Box
                                          data-test-id='roles_list_item'
                                          key={item}
                                          className='listingItem'
                                        >
                                          {item}
                                        </Box>
                                      );
                                    }
                                  )}
                                </Box>
                                {this.state.listingDataShow.length <= 0 && (
                                  <Box style={webStyle.noDataFound}>
                                    {`No Stores found`}
                                  </Box>
                                )}
                                <Button
                                  data-test-id='closePermissionModal'
                                  style={webStyle.modalCancelBtn}
                                  onClick={() => this.handleCloseStoreList()}
                                >
                                  Cancel
                                </Button>
                              </Box>
                            </Modal>
                          )}

                          {this.state.dialogPayload?.action === "View" && (
                            <StyledDialog
                              open={true}
                              onClose={() => this.handleToggleDialog()}
                              className='size-sm'
                            >
                              <h3 className='dialog-title'>
                                Store Discount Usage
                              </h3>

                              {this.renderDialog()}
                            </StyledDialog>
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>

                  {this.state.isLoading && (
                    <>
                      {Array(5)
                        .fill(1)
                        .map((_, index) => (
                          <TableBody key={index} data-test-id='skeletonTable'>
                            <TableRow>
                              {[...Array(6)].map((_, cellIndex) => (
                                <TableRowsSkeleton key={cellIndex} />
                              ))}
                            </TableRow>
                          </TableBody>
                        ))}
                    </>
                  )}
                </Table>

                {storeDiscountList.length === 0 && (
                  <NoRecordFoundText>
                    {Strings.noRecordFounds}
                  </NoRecordFoundText>
                )}
              </TableContainer>

              {storeDiscountList.length != 0 && (
                <TablePagination
                  component='div'
                  count={totalCount}
                  page={this.currentPage - 1}
                  rowsPerPage={this.rowPerPage}
                  rowsPerPageOptions={[10]}
                  onRowsPerPageChange={(
                    e: React.ChangeEvent<{ value: unknown }>
                  ) => {
                    this.rowPerPage = e.target.value as number;
                    this.getPromoCodesApi();
                  }}
                  onPageChange={(_, page: number) =>
                    this.onChangePage(page + 1)
                  }
                />
              )}
            </Box>
          </MainBoxWrapper>
          {this.getPopoverData()}
        </>
      </MuiPickersUtilsProvider>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
const NoRecordFoundText = styled("div")({
  fontSize: 16,
  fontWeight: 600,
  textAlign: "center",
});

export const PageTitle = styled("div")({
  fontFamily: "Montserrat",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "24px",
  lineHeight: "29px",
  "@media only screen and (max-width: 1024px)": {
    fontSize: "16px",
  },
});

const MainBoxWrapper = styled("div")({
  "& .filterButtonAccount": {
    position: "relative",
    marginRight: "24px",
    cursor: "pointer",
    background: colors().white,
    height: "56px",
    color: colors().darkliver,
    width: "56px",
    fontSize: "24px",
    borderRadius: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid",
    borderColor: colors().lightborder,
    "@media only screen and (max-width: 1024px)": {
      fontSize: "16px",
      width: "44px",
      height: "44px",
    },
  },
  "& .MuiTableCell-root": {
    verticalAlign: "middle",
    paddingTop: "14px",
    paddingBottom: "14px",
  },

  "& .MuiTableRow-root": {
    height: "70px",
  },

  "& .MuiTableCell-root > *": {
    display: "flex",
    alignItems: "center",
  },

  "& .statusLastColumn": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "4px",
    height: "100%",
  },
  "& .active-filter-border": {
    borderColor: colors().cyancobaltblue,
  },
  "& .filterActiveIcon": {
    position: "absolute",
    top: "-5px",
    right: "-5px",
    minWidth: "15px",
    background: colors().cyancobaltblue,
    minHeight: "15px",
    borderRadius: "50%",
  },
  "& .addButton": {
    background: colors().cyancobaltblue,
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    color: colors().white,
    height: "56px",
    width: "184px",
    borderRadius: "8px",
    textTransform: "unset",
    "@media only screen and (max-width: 1024px)": {
      fontSize: "13px",
      width: "160px",
      height: "44px",
    },
  },
});

const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    padding: 32,
    minWidth: 788,
    maxWidth: 900,
    borderRadius: 12,
    "&.size-sm": {
      minWidth: 554,
      width: 554,
    },
    "& .confirmation-img": {
      width: 64,
      height: 64,
      alignSelf: "center",
    },
    "& .dialog-title": {
      textAlign: "center",
      fontWeight: 600,
      fontSize: 24,
      lineHeight: 2,
      color: colors().viewTextColor,
      marginBottom: 24,
    },
    "& .dialog-actions": {
      display: "flex",
      justifyContent: "center",
      gap: 24,
      marginTop: 24,
      "& > button": {
        padding: 16,
        borderRadius: 8,
        width: 186,
        background: colors().cyancobaltblue,
        color: "white",
        fontWeight: 600,
        fontSize: 16,
        cursor: "pointer",
        border: "none",
        "&.cancel-btn": {
          background: colors().antiFlashWhite,
          color: colors().slateGray,
        },
      },
    },
    "& .dialog-text-content": {
      fontSize: 20,
      lineHeight: "28px",
      textAlign: "center",
    },
    "& .form-body": {
      display: "grid",
      gridTemplateColumns: "0.5fr 0.5fr",
      gap: 32,
      "& .MuiInputBase-root.Mui-disabled": {
        background: colors().lightborder,
      },
      "& .autocomplete-field": {
        "& .MuiAutocomplete-root": {
          paddingTop: 6,
          "& .MuiOutlinedInput-root": {
            border: 0,
          },
          "& .MuiInputBase-input": {
            "&::placeholder": {
              opacity: 1,
              color: colors().darkliver,
              fontSize: 14,
              fontFamily: "Montserrat",
              fontWeight: 400,
              "@media only screen and (max-width: 1024px)": {
                fontSize: 12,
              },
            },
          },
          "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
            {
              borderColor: "red",
            },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: colors().lightborder,
          },
        },
      },
      "& .date-field": {
        "& .MuiPickersBasePicker-pickerView .MuiTypography-root": {
          fontFamily: "Montserrat",
          fontSize: "0.875rem",
        },
        "& .MuiPickersCalendarHeader-transitionContainer .MuiTypography-root": {
          fontWeight: 700,
          color: colors().darkjunglegreen,
        },
        "& .MuiPickersDay-daySelected": {
          border: `solid 1px ${colors().dividerColor}`,
          background: colors().brightgray,
          color: colors().cyancobaltblue,
        },
        "& .MuiFormControl-root": {
          width: "100%",
          paddingTop: 6,
        },
        "& .MuiInputBase-root": {
          borderWidth: 1,
          "&.Mui-error": {
            border: "1px solid red",
          },
        },
        "& .MuiInputBase-input": {
          padding: "18.5px 14px !important",
        },
        "@media only screen and (max-width: 1024px)": {
          "& .PickerWithState-root-35 div button": {
            padding: 6,
          },
        },
      },
    },
    "& .view-status-dialog": {
      "& .dialog-content": {
        boxShadow: "0px 2px 8px 0px #00000014",
        padding: 16,
        borderRadius: 16,
      },
      "& .status-row": {
        padding: 8,
        borderRadius: 8,
        display: "grid",
        gridTemplateColumns: "0.5fr 0.5fr",
        gap: 32,
        "&:nth-of-type(even)": {
          background: colors().ghostwhite,
          borderRadius: 8,
        },
      },
      "& .row-value": {
        fontSize: 14,
        lineHeight: "22px",
        minHeight: 22,
      },
    },
  },
});

export const webStyle = {
  table: {
    minWidth: 700,
  },
  mainWrapper: {
    marginTop: "32px",
    fontFamily: "Montserrat",
  },
  noPermissions: {
    padding: "0 8px",
  },
  pageHeader: {},
  headerWrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 32,
    alignItems: "center",
    flexWrap: "wrap" as "wrap",
  },

  modalCancelBtn: {
    minHeight: "56px",
    width: "126px",
    backgroundColor: "rgba(32, 75, 156, 0.1)",
    borderRadius: "8px",
    marginTop: "32px",
    fontSize: "16px",
    lineHeight: "24px",
    color: "rgba(100, 116, 139, 1)",
    fontWeight: 600,
    textTransform: "capitalize" as const,
  },

  modalHeading: {
    fontSize: "24px",
    lineHeight: "24px",
    fontFamily: "Montserrat",
    margin: "0 0 16px 0",
  },
  addButton: {
    fontFamily: "Montserrat",
    background: "#204B9C",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#FFFFFF",
    height: "56px",
    width: "184px",
    borderRadius: "8px",
  },
  contentWrapper: {
    marginRight: 32,
    marginTop: 32,
    marginLeft: 48,
    paddingTop: 64,
  },

  headerButtonPartAccount: {
    display: "flex",
  },

  popoverButton: {
    cursor: "pointer",
    width: "118px",
    height: "33px",
    paddingLeft: "24px",
    backgroundColor: "#FFFFFF",
    color: "#4D4D4D",
    "&:hover": {
      backgroundColor: "#204B9C",
      color: "#FFFFFF",
    },
    paddingTop: "8px",
  },
  popoverContainer: {
    paddingTop: "16px",
    paddingBottom: "16px",
    boxShadow:
      "0px 4px 8px rgba(0, 0, 0, 0.03), 0px 8px 32px rgba(0, 0, 0, 0.06)",
    borderRadius: "8px",
    fontFamily: "Montserrat",
    fontWeight: 500,
    fontSize: "14px",
  },
  filterButtonAccount: {
    marginRight: "24px",
    cursor: "pointer",
    background: "#FFFFFF",
    height: "56px",
    color: "#4d4d4d",
    width: "56px",
    fontSize: "24px",
    borderRadius: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #204B9C",
  },
  noDataFound: {
    fontSize: "20px",
    lineHeight: "20px",
    fontFamily: "Montserrat",
    padding: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    margin: "16px 0",
    fontWeight: 500,
  },
};

// Customizable Area End

export default StoreDiscountList;
